import React, {Fragment} from 'react';
import {formatAmountValue} from 'utils/valueFormatter.function';
import BatchButtons from '../input/SplitSignButton.component';
import { Notification, NotificationType } from "components/common/Notification.component";

interface BatchDocument {
    taskId: string;
    details: {
        currency: string;
        maxApprovedAmount: number;
    };
}

interface BatchType {
    id: string;
    version: string;
    documents: BatchDocument[];
    redirectUrl: string;
    state: string;
}

interface NewPaymentBatchProps {
    batch: BatchType;
    translate: (...args: any[]) => string;
    navigate?: any;
}


const NewPaymentBatch: React.FC<NewPaymentBatchProps> = ({batch, translate}) => {

    const numTasks = batch && batch.documents ? batch.documents.length : '';

    let currencyTotal = 0;
    let currency = '';
    if (numTasks !== '') {
        batch.documents.forEach(doc => {
            if (currency === '') {
                currency = doc.details.currency;
            }
            if (doc.details.currency === currency) {
                currencyTotal += doc.details.maxApprovedAmount;
            } else {
                currencyTotal = 0;
                return;
            }
        });
    }

    const title =
        currencyTotal > 0 ? translate('myTasks.newSignBundleCurrency', numTasks, formatAmountValue(currencyTotal) + ' ' + currency)
            : translate('myTasks.newSignBundle', numTasks);

    return (
        <Fragment>
            <div className="d-flex justify-content-center">
                <Notification
                    type={NotificationType.DEFAULT}
                    description={title}
                    btnToolbar={
                        <BatchButtons
                            batch={batch}
                            translate={translate}
                        />
                    }
                    title={translate('myTasks.approveAndPay')}
                />
            </div>
        </Fragment>
    );
};

export default NewPaymentBatch;